import moment from 'moment-timezone';
import {ProjectColors} from "./projectColors";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";

const maxCharLength = 50;

export function timeFormatter(utcTime, hideTimeZone) {
    if (utcTime) {
        return moment.utc(utcTime).tz('Europe/Brussels').format('MMMM D YYYY, hh:mm:ss a');
    }
}

export function formatDate(date) {
    if (!date) {
        return '';
    }
    const formattedString = moment(date).format('lll');
    return formattedString === 'Invalid date' ? '' : formattedString;
}

export function formatDateTime(date) {
    if (!date) {
        return '';
    }
    const formattedString = moment(date).format('HH:mm:ss');
    return formattedString === 'Invalid date' ? '' : formattedString;
}

export function cellFormatter(cell) {
    return (
        <>
            {cell?.length > maxCharLength ? <OverlayTrigger overlay={<Tooltip> {cell}</Tooltip>}>
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    {cell}
                </div>
            </OverlayTrigger> : <div style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {cell}
            </div>}
        </>
    )
}

export function cellTimeFormatter(cell) {
    cell = cell ? moment(cell).format('lll') : '';
    return cellFormatter(cell);
}

export function durationFormatter(cell) {
    if (!cell) return '00:00';
    let numOfSecondsInDay = 60 * 60 * 24;
    let days = Math.floor(cell / numOfSecondsInDay);
    let time = new Date(cell * 1000).toISOString().substr(11, 5);
    return (days > 0) ? `${days} days, ${time}` : `${time}`;
}

export function getLastWeekStartDate() {
    return moment().subtract(6, 'days').toDate();
}

export function getLastWeekEndDate() {
    return moment().toDate();
}

export function timeFormatterNoDate(utcTime, hideTimeZone) {
    if (utcTime) {
        return moment.utc(utcTime).tz('Europe/Brussels').format('hh:mm a');
    }
}

export function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getProductionLineId(globalState) {
    return typeof globalState.state.selectedProductionLine === 'string' ? JSON.parse(globalState.state.selectedProductionLine).id : globalState.state.selectedProductionLine.id
}

export function removeFractionDigits(value) {
    return Math.round(parseInt((value)));
}

export function turnAlertsIntoObjectArray(data) {
    let newData;
    newData = data.map(obj => {
        let timeSeriesNewArray = [];
        if (obj.name === 'Alerts') {
            timeSeriesNewArray = obj.timeSeriesData.map(timeObj => {
                return {x: timeObj[0], y: timeObj[1]};
            })
            return {...obj, timeSeriesData: timeSeriesNewArray};
        } else {
            return obj;
        }
    })
    return newData;
}

export function addAlertMarkers(data, fullData) {
    let newData;
    let alertTimesArray = fullData.alertTimestamps;
    newData = data.map((obj, index) => {
        let timeSeriesNewArray = [];
        timeSeriesNewArray = obj.timeSeriesData.map((timeObj, index) => {
            let indexFound = alertTimesArray?.indexOf(timeObj?.x);
            if (indexFound !== -1 && obj.name === 'Alerts') {
                return {
                    ...timeObj,
                    marker: {symbol: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABOCAYAAAA3vqZVAAAAAXNSR0IArs4c6QAABYFJREFUaEPtl2tIlFkYx89zzutcbBxbV8t2Xahsl4woY8XCDFZqpVhltrQEYT8Eu1psRmEUuAVDsNGFiMDEjVrtRjR+kJEoCslK1ClcWjL31gfdbrPMrrpeRp2Z95xnmWlncHLeuWhDX15hPvm+z+/8/+c5z/+8QN7RH7wjLokJjIQAqarSkNHR1+8tXEhISgqSwUEPmM0iFhERwVhRkeArODQEfOXKrWg01tOJCUYAUGi1iGlpY2Rw0JQgxM9EqxVQWemJZgFhwVhVpeUFBedIf/97xOHIJi9epOOjRxTGx33vocFAMD0dISeHk2XLJogs10tdXd/B2bMR4YpgtFgM3On8EdvbvwSrldKBAe+z/l+QKCQEMTWViOJiD0lN3Z8wZ84PYDZPhlMeEowWC5Ndrl9IY+Ni+uCBBGNjvhqoUMlfBA0GFGvzPHLp1t91L19mh9v3IDAiAmltXe5xOq/Ta9cywGoF8r+tXqaSPUEL0uuRl5cjFhc7NMnJi6CgIKTyYLDFouHJyeuxpcUKzc0SffUK/EUjdeHU53DBAhQlJTKWln6bYDA0Qk7OtD0Pqufq6FhORkZOsEOHCml3N/XbGwnq3wEv3P8sz85GUVs7wbKyellKSh4AyFN3KlATzWbKy8v7eFPTB6y2llG73ac2WuibcJGRQXhNjWDFxU6WkZESFixKSlzy4cOSdOsWgZERXzPNFIxGIxFlZUirqwW123VQUKCg2GJhmJnplqurKevqIuByzQ6s1xOxbh2yo0cFDA9HAC9a5Jb37qXs4UMCbvfswDodEfn5yI4f5zA8rFdWbDZTNJk8ck0NZffuERgfnx04MZGIoiJB9+8foaOjaWHBoqxsXD55UiM1NxMYGJhVc+G8ecgrKzndsuUn9vTpWti2jYfuakQQPT0VcmfnKXbkiI4+ezY78JIlXN6166YmN3cb5OVNvDn0ggdIW5vk6u1dLF2+/Cu12WZ1jjEnR6a5uR9BXd1foSbttNOCZrPEnzyZhBs3WKz77D9+KEkEN23yMJ1OD01NQRb7FzEd7A2IsbG/oaFhLm1vj8luP1hkZiKWlLikvj5D1GDfmLx4cY7o7f2XHDsmhQuHNy30g3lhocDNm20JO3fmg0KoKcYi2u1OceCAhk5ORgyKoIAAQDx40MMYSwKz2a2UyYpgnph4ndy8+Tmtr6fIue+5SLEIAIRnZQmyfftjyen8NOo8nro6bGuT+PPnf8COHQv9mRwO7P0fMoZiz55RKSkpLZzasNvnTSuxdOnX5Pz5WnL3rgQeT8hGCwQJABHp6dyzYcPH+kuX+iJd+MJf9iwWxnt6voI7d85BRwcLlVaBI+S99qxf75Q0mrlKnRxycimtEM1mnXA4RsiFCxI4nUGqpywEyerVHJKTP4Tbtx2R1EZ1UnyWr1r1Aq5cSSdNTYCIgSYLqDUakXzxxZ/06tXFSscn7MhUVN3QoCNa7RDu3q3FgQHvgQncOr0gUVjoFkJ8pmlttUWjNirFvoHiVZ2fP0TOnEmClhZA/noK+jqZUiQm00na3HwACIn6Mybqmw1aLBoxOvqY7Nv3ifdzxgdmDLnJNCnZ7e9DV9e0BAqnPmqwT7nVukWcPm0h9+9T4Bxw/nzkGzfu1TQ2no7WYsWQCFcAOzsrhM12AurqktCb10VFbrZihT7WL8Wo9zhwdW1rk4jNloQ22z/C4QCxZs03mlOnzseqNmawz27vTaWlxY1uN2e9vcZIozGmkIikQO7vv8S6u7+H0tLfIj37VsFe1QCBtJwRO6aunhFB4SUV/DbdDFtLtVq1Om4OqM0VN2tndNmLx2rUPY6HqyFrqlarVsfNAbW54matOqvV5lKbK24OqM0VN2vVyaU2l9pccXPgPx4Qb22HevBVAAAAAElFTkSuQmCC)'},
                    enabled: true,
                    radius: 4,
                    zIndex: 5
                }
            } else {
                return timeObj;
            }
        })
        return {...obj, timeSeriesData: timeSeriesNewArray};
    })
    return newData;
}

export const renderLogo = (globalState, setIsImageLoaded) => {
    const company = process.env.REACT_APP_COMPANY_NAME;
    switch (company) {
        case 'Coca-Cola':
            return <img
                onLoad={() => setIsImageLoaded(true)}
                src={require("../Images/coca-cola-logo-small.png")}
                alt="logo"
            />
        case 'PepsiCo':
            return <img
                onLoad={() => setIsImageLoaded(true)}
                src={require("../Images/wint-pepsico-logo-small.png")}
                alt="logo"
            />
        default:
            return null
    }
}


export const sensorChartColors = [ProjectColors.Blue, ProjectColors.LightBlue, ProjectColors.LightGreen, ProjectColors.Orange, ProjectColors.Yellow, ProjectColors.Purple];


export const mockData = {
    data:
        {
            'verticalLineTimestamps': [1657232715000, 1657232880000, 1657233045000, 1657233195000, 1657233285000],
            'sensors': [
                {
                    'name': 'TC_WINT_FT3601_drLimeWatFRate',
                    'label': 'Lime Slurry Water Flowrate',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 0.0122451782226562,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 0.0122451782226562], [1657232730000, 0.0122451782226562], [1657232745000, 0.0122451782226562], [1657232760000, 0.0122451782226562], [1657232775000, 0.0122451782226562], [1657232790000, 0.0122451782226562], [1657232805000, 0.0122451782226562], [1657232820000, 0.0122451782226562], [1657232835000, 0.0122451782226562], [1657232850000, 0.0122451782226562], [1657232865000, 0.0122451782226562], [1657232880000, 0.0122451782226562], [1657232895000, 0.0122451782226562], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 0.0122451782226562], [1657232955000, 0.0122451782226562], [1657232970000, 0.0122451782226562], [1657232985000, 0.0122451782226562], [1657233000000, 0.0122451782226562], [1657233015000, 0.0122451782226562], [1657233030000, 0.0122451782226562], [1657233045000, 0.0122451782226562], [1657233060000, 0.0122451782226562], [1657233075000, 0.0122451782226562], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 0.0122451782226562], [1657233135000, 0.0122451782226562], [1657233150000, 0.0122451782226562], [1657233165000, 0.0122451782226562], [1657233180000, 0.0122451782226562], [1657233195000, 0.0122451782226562], [1657233210000, 0.0122451782226562], [1657233225000, 0.0122451782226562], [1657233240000, 0.0122451782226562], [1657233255000, 0.0122451782226562], [1657233270000, 0.0122451782226562], [1657233285000, 0.0122451782226562]]
                },
                {
                    'name': 'TC_WINT_FT3902_drPushWaterFlow',
                    'label': 'Kettle to Soak Tank discharge push water flow  meter (Fresh Water)',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 32.5593376159668,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 0.04766536876559251], [1657232730000, 0.04961089417338365], [1657232745000, 0.05739299580454822], [1657232760000, 0.0515564195811748], [1657232775000, 0.03793774172663682], [1657232790000, 0.04961089417338365], [1657232805000, 0.05544747039675708], [1657232820000, 0.05933852121233936], [1657232835000, 0.04961089417338365], [1657232850000, 0.04961089417338365], [1657232865000, 0.05544747039675708], [1657232880000, 0.05933852121233936], [1657232895000, 0.061284046620130504], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 0.05763618648052211], [1657232955000, 0.05350194498896594], [1657232970000, 0.045719843357801375], [1657232985000, 0.05350194498896594], [1657233000000, 0.04766536876559251], [1657233015000, 0.04766536876559251], [1657233030000, 0.05544747039675708], [1657233045000, 0.05544747039675708], [1657233060000, 21.355642121036848], [1657233075000, 32.5593376159668], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 32.530155181884766], [1657233135000, 32.40369669596354], [1657233150000, 32.47626444498698], [1657233165000, 32.47957229614258], [1657233180000, 32.4344362894694], [1657233195000, 32.499027252197266], [1657233210000, 32.31167424519857], [1657233225000, 32.41906712849935], [1657233240000, 32.45700454711914], [1657233255000, 32.31712061564128], [1657233270000, 32.35155690511068], [1657233285000, 32.35175120035807]]
                },
                {
                    'name': 'TC_WINT_FT3101_drKt1FRate',
                    'label': 'Kettle 1 Fresh Water Flow Rate - 2bar',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 295.6586853027344,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 293.88490193684896], [1657232730000, 295.25127970377605], [1657232745000, 295.6586853027344], [1657232760000, 59.03646647135417], [1657232775000, 0.0], [1657232790000, 0.0], [1657232805000, 0.0], [1657232820000, 0.0], [1657232835000, 0.0], [1657232850000, 0.0], [1657232865000, 0.0], [1657232880000, 0.0], [1657232895000, 0.0], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 0.0], [1657232955000, 0.0], [1657232970000, 0.0], [1657232985000, 0.0], [1657233000000, 0.0], [1657233015000, 0.0], [1657233030000, 0.0], [1657233045000, 0.0], [1657233060000, 0.0], [1657233075000, 0.0], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 0.0], [1657233135000, 0.0], [1657233150000, 0.0], [1657233165000, 0.0], [1657233180000, 0.0], [1657233195000, 0.0], [1657233210000, 0.0], [1657233225000, 0.0], [1657233240000, 0.0], [1657233255000, 0.0], [1657233270000, 0.0], [1657233285000, 0.0]]
                },
                {
                    'name': 'TC_WINT_FT3201_drKt2FRate',
                    'label': 'Kettle 2 Fresh Water Flow Rate - 2bar',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 0.0,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 0.0], [1657232730000, 0.0], [1657232745000, 0.0], [1657232760000, 0.0], [1657232775000, 0.0], [1657232790000, 0.0], [1657232805000, 0.0], [1657232820000, 0.0], [1657232835000, 0.0], [1657232850000, 0.0], [1657232865000, 0.0], [1657232880000, 0.0], [1657232895000, 0.0], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 0.0], [1657232955000, 0.0], [1657232970000, 0.0], [1657232985000, 0.0], [1657233000000, 0.0], [1657233015000, 0.0], [1657233030000, 0.0], [1657233045000, 0.0], [1657233060000, 0.0], [1657233075000, 0.0], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 0.0], [1657233135000, 0.0], [1657233150000, 0.0], [1657233165000, 0.0], [1657233180000, 0.0], [1657233195000, 0.0], [1657233210000, 0.0], [1657233225000, 0.0], [1657233240000, 0.0], [1657233255000, 0.0], [1657233270000, 0.0], [1657233285000, 0.0]]
                },
                {
                    'name': 'TC_WINT_FT4101_drCornWashFlow',
                    'label': 'corn wash  drum fresh water flow meter',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 24.12698554992676,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 23.49792544047038], [1657232730000, 23.527880732218424], [1657232745000, 23.53699722290039], [1657232760000, 23.857388051350913], [1657232775000, 24.12177594502767], [1657232790000, 24.06837730407715], [1657232805000, 24.098332722981773], [1657232820000, 24.090518188476565], [1657232835000, 24.094425201416016], [1657232850000, 24.05926005045573], [1657232865000, 24.02669995625814], [1657232880000, 24.11917114257813], [1657232895000, 24.12698554992676], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 24.09768152236939], [1657232955000, 24.091820398966473], [1657232970000, 24.050143559773762], [1657232985000, 24.081401189168293], [1657233000000, 24.055353418986], [1657233015000, 24.080098978678386], [1657233030000, 24.080098724365236], [1657233045000, 24.060562515258788], [1657233060000, 24.060562260945634], [1657233075000, 24.02930450439453], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 24.02930450439453], [1657233135000, 23.99413998921712], [1657233150000, 23.98762804667155], [1657233165000, 24.030606969197592], [1657233180000, 24.012373606363933], [1657233195000, 24.03321215311686], [1657233210000, 23.990232721964517], [1657233225000, 24.008466466267905], [1657233240000, 24.012373606363933], [1657233255000, 23.968091837565105], [1657233270000, 24.00195426940918], [1657233285000, 23.999349466959636]]
                },
                {
                    'name': 'TC_WINT_MW_PID_drPV',
                    'label': 'Mill Water Flow PID Process Variable ',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 56.117217508951825,
                    'tags': [],
                    'timeSeriesData': [[1657232715000, 55.37484639485677], [1657232730000, 54.62270991007487], [1657232745000, 55.306471252441405], [1657232760000, 55.93162409464518], [1657232775000, 56.117217508951825], [1657232790000, 54.52503026326497], [1657232805000, 53.8998774210612], [1657232820000, 53.99755783081055], [1657232835000, 54.2026865641276], [1657232850000, 54.27106221516927], [1657232865000, 53.870574442545575], [1657232880000, 53.86080627441406], [1657232895000, 53.91941452026367], [1657232910000, 0.0], [1657232925000, 0.0], [1657232940000, 52.06959629058838], [1657232955000, 52.874237060546875], [1657232970000, 53.51892598470052], [1657232985000, 52.29792455037435], [1657233000000, 52.415140533447264], [1657233015000, 52.336996459960936], [1657233030000, 52.67887700398763], [1657233045000, 52.88400522867838], [1657233060000, 51.965812174479176], [1657233075000, 52.01465225219727], [1657233090000, 0.0], [1657233105000, 0.0], [1657233120000, 52.38095283508301], [1657233135000, 52.27838872273763], [1657233150000, 52.122100321451825], [1657233165000, 52.31746063232422], [1657233180000, 52.75702107747396], [1657233195000, 52.03418833414714], [1657233210000, 51.43833897908529], [1657233225000, 51.3992665608724], [1657233240000, 50.891330973307284], [1657233255000, 50.83272323608398], [1657233270000, 50.91086705525716], [1657233285000, 50.86202697753905]]
                },
                {
                    'name': 'Alerts',
                    'label': 'Alerts',
                    'unitSymbol': '\u2113/hour',
                    'unitLabel': 'litres per HOUR',
                    'minVal': 0,
                    'maxVal': 0,
                    'tags': [],
                    'timeSeriesData': [[1657232970000, 0.0]]
                }
            ]
        }
}
